module.exports = __webpack_public_path__ + "static/media/createUserScreen.ea7f6a26.png";